export { default } from './DigDeleteLanguageModal';
